import { appstr } from "../utils/appstr";
import { checkhysteresis } from "../utils/checkhysteresis";
import { checkSession } from "../utils/checkSession";
import { copyTextToClipboard } from "../utils/copyTextToClipboard";
import { CreateCanvas } from "../utils/CreateCanvas";
import {
  enumBasicToolModes,
  enumElementDrawStates,
  enumKeyboardTargetEnterAction,
  enumMarqueeBehavior,
  enumPanelMode,
  enumWSInteractMode,
  kCBTextContent,
  kCtrlKey,
  kShiftKey
} from "../constants";
import { EventToKeyInfo } from "../utils/EventToKeyInfo";
import { handleSimTimer } from "../utils/handleSimTimer";
import { QAlert } from "./QAlert";
import { QChartBox } from "./QChartBox";
import { QChartBoxCell } from "./QChartBoxCell";
import { QClipboard } from "./QClipboard";
import { QClipboardBuffer } from "./QClipboardBuffer";
import { QImageMgr } from "./QImageMgr";
import { QKeyboardTarget } from "../utils/QKeyboardTarget";
import { QPanelHitTest } from "../utils/QPanelHitTest";
import { QTracker } from "./QTracker";
import { SetOnBeforeUnload } from "../utils/SetOnBeforeUnload";
import { doDrawImage2 } from "../utils/doDrawImage2";
import { Globals } from "./Globals";
import { setupCanvas } from "../utils/setupCanvas";
import { QCmd } from "./QCmd";
import { DragReady } from "../utils/DragReady";
import { CRC32 } from "../utils/CRC32.js";
import { getsessioninfo } from "../utils/getsessioninfo.js";
import { copyTextToClipboardNoEvent } from "../utils/copyTextToClipboardNoEvent.js";

export class QWSMgr {
  constructor() {
    this.fCanvas = null;
    this.fDoc = null;
    //this.fCmdMgr = null;
    this.fPanels = null;
    this.fPrepRenderSubs = null;

    this.fImageMgr = null;
    this.fTracker = null;
    this.fTargetElement = null;
    this.fTargetPanel = null;
    this.fActiveDragPanel = null;

    // Keyboard handling
    this.fKeyboardTarget = null;
    this.fKeyboardTargetPanel = null;
    this.fKeyboardTargetStack = null;

    this.fLoadedImageCount = 0;
    this.fBackBuffer = null;

    // General Dragging (Pan, Marquee and Drag Element)
    this.fDragStartx = 0;
    this.fDragStarty = 0;

    // Panning of panel
    this.fOrigPanX = 0;
    this.fOrigPanY = 0;

    this.fInteractMode = enumWSInteractMode.standardMode;

    // Modifier key handling
    this.fShiftKeyDown = false;
    this.fCtrlKeyDown = false;
    this.fPrevHoverElement = null;
    this.fCurrentHoverElement = null;

    this.fClipboard = null;

    this.fCurCursor = "default";
    this.fPauseDrawing = false;
    this._renderQueued = false;
    this._renderFrameHandle = null;
    this.fSessionTimer = null;

    //Panel ZOrder
    this.fZLayers = null;
    this.fDocContextProviderFn = null;
  }

  SetDoc(activeDoc) {
    this.fDocMgr.SetCurrentDoc(activeDoc);
  }

  GetDoc() {
    var dm = this.fDocMgr;
    if (dm == null) return null;

    return dm.GetCurrentDoc();
  }

  ResetWorkspace() {
    if (this.fLoginPanel) this.RemovePanel(this.fLoginPanel);
    this.fLoginPanel = null;
    this.ClearAppLoadingAnimation();
    for (var i = 0; i < this.fPanels.length; i++) this.RemovePanel(this.fPanels[i]);
    this.CreateWS();

    this.ResetToolbars();
  }

  InitWS(theCanvas, imageFiles) {
    this.fCanvas = theCanvas;

    this.fBackBuffer = CreateCanvas(); // document.createElement('canvas');
    this.fBackBuffer.width = theCanvas.width;
    this.fBackBuffer.height = theCanvas.height;
    this.fBackBuffer.style.width = theCanvas.style.width;
    this.fBackBuffer.style.height = theCanvas.style.height;

    this.fPanels = [];
    this.fZLayers = [[], [], []];

    this.fKeyboardTargetStack = [];

    this.fPrepRenderSubs = [];
    this.fTracker = new QTracker();
    this.fTracker.fWSMgr = this;
    this.fImageMgr = new QImageMgr();
    this.fImageMgr.InitImageMgr(imageFiles, this);

    this.fClipboard = this.CreateClipboard();
  }

  GetUsageTracker() {
    return this.fTracker;
  }

  GetImageMgr() {
    return this.fImageMgr;
  }

  GetCanvasWidth() {
    return parseInt(this.fCanvas.style.width);
  }

  GetCanvasHeight() {
    return parseInt(this.fCanvas.style.height);
  }

  PushPanel(aPanel) {
    aPanel.SetBackBuffer(this.fBackBuffer);
    /*
    if (aPanel.fTrackDuration)
      aPanel.fEnterTime = performance.now();
     */

    this.fPanels.push(aPanel);
    if (aPanel.fZLayer == null) aPanel.fZLayer = 2; //Setting to 1 here (not 0) is intentional.
    if (this.fZLayers.length <= aPanel.fZLayer) {
      //make new zlayers if you specify a new zlayer.
      for (var aNewLayer = this.fZLayers.length; aNewLayer <= aPanel.fZLayer; aNewLayer++) {
        this.fZLayers[aNewLayer] = [];
      }
    }
    this.fZLayers[aPanel.fZLayer].push(aPanel);

    if (aPanel.GetModalOn()) {
      var curTarget = new QKeyboardTarget();

      curTarget.fKeyboardTargetElement = this.fKeyboardTarget;
      curTarget.fKeyboardTargetPanel = this.fKeyboardTargetPanel;
      this.fKeyboardTargetStack.push(curTarget);
    }
    aPanel.SetWSMgrRef(this);
    aPanel.GainFocus();
  }

  RemoveElement(anElement) {
    console.log("When is this used?");
    var numPanels = this.fPanels.length;
    for (var i = 0; i < numPanels; i++) {
      var thePanel = this.fPanels[i];
      if (thePanel.RemoveElement(anElement)) return;
    }
  }

  DropPanelReference(aPanel) {
    var index = this.fPanels.indexOf(aPanel);
    if (index > -1) {
      this.fPanels.splice(index, 1);

      if (aPanel.GetModalOn()) {
        var prevTarget = this.fKeyboardTargetStack.pop();
        // In the rare case that the keyboard target is deleted prior to being popped we get to it we need to check "invalid"
        if (
          prevTarget != null &&
          prevTarget.fKeyboardTargetElement != null &&
          prevTarget.fKeyboardTargetElement.fClosed !== true
        ) {
          this.SetKeyboardTarget(
            prevTarget.fKeyboardTargetElement,
            prevTarget.fKeyboardTargetPanel,
            enumKeyboardTargetEnterAction.noAction
          );
          if (prevTarget.fKeyboardTargetPanel)
            prevTarget.fKeyboardTargetPanel.DoSelectElement(
              prevTarget.fKeyboardTargetElement,
              true
            );
        } else {
          var prevPanel = null;
          if (prevTarget) prevPanel = prevTarget.fKeyboardTargetPanel;
          this.SetKeyboardTarget(null, prevPanel, enumKeyboardTargetEnterAction.noAction);
        }
      } else {
        var targetPanel = this.GetKeyboardTargetPanel();
        if (aPanel == targetPanel)
          this.SetKeyboardTarget(null, null, enumKeyboardTargetEnterAction.noAction);
      }
    } else console.log("FAILURE - RemovePanel");
    var zIndex = this.fZLayers[aPanel.fZLayer].indexOf(aPanel);
    if (zIndex > -1) {
      this.fZLayers[aPanel.fZLayer].splice(zIndex, 1);
    } else console.log("FAILURE - ZRemovePanel");
  }

  // Apr1
  RemovePanel(aPanel) {
    this.DropPanelReference(aPanel);

    aPanel.LoseFocus();
    aPanel.ClosePanel();
  }

  // Apr1
  MakePanelTop(aPanel) {
    var zIndex = this.fZLayers[aPanel.fZLayer].indexOf(aPanel);
    if (zIndex > -1) {
      this.fZLayers[aPanel.fZLayer].splice(zIndex, 1);
      this.fZLayers[aPanel.fZLayer].push(aPanel);
    }
  }

  PrepRenderWS() {
    if (this.fPrepRenderSubs == null) return; //Viewer loads much faster than WB
    var numSubscribers = this.fPrepRenderSubs.length;
    for (var i = 0; i < numSubscribers; i++) {
      var subscriber = this.fPrepRenderSubs[i];
      subscriber.SubPrepRender(this);
    }
    //TODO: Doesn't really need refactoring? This isn't used for hit testing or rendering just flagging.
    var numPanels = this.fPanels.length;
    for (var i = 0; i < numPanels; i++) {
      var thePanel = this.fPanels[i];
      if (thePanel.IsShown()) thePanel.PrepRender(this);
    }
  }

  RenderBackground() {
    var ctx = this.fBackBuffer.getContext("2d");
    ctx.fillStyle = "#EF22FF";
    ctx.fillRect(0, 0, this.fBackBuffer.width, this.fBackBuffer.height);
  }

  SetHoverState() {
    var pHover = this.fPrevHoverElement;
    var cHover = this.fCurrentHoverElement;
    if (pHover != null && pHover != cHover) {
      if (pHover.IsEnabled()) pHover.SetDrawState(enumElementDrawStates.Std);
    }

    if (cHover != null && cHover.IsEnabled()) {
      var curDrawState = cHover.GetDrawState();
      if (curDrawState == enumElementDrawStates.Std && !Globals._mobileDevice)
        cHover.SetDrawState(enumElementDrawStates.Hover);
    }
  }

  DoPerfTest() {
    Globals._rolling = 0;
    Globals._average = 0;
    Globals._reportPerf = true;

    for (var i = 0; i < 50; i++) {
      this.RenderWS();
    }

    var fps = 1000 / (Globals._average / Globals._rolling);
    var w = new QAlert();
    w.InitAlert(appstr("Alert"), "Frames per second:" + fps.toFixed(2), null, this);
    Globals._reportPerf = false;

    console.log("Average Render Time:", Globals._average / Globals._rolling);
  }

  DoActivityReport() {
    //**
    window.onbeforeunload = null;
    var curOrg = this.GetAccountName();
    var user = this.GetUserName();
    curOrg = encodeURIComponent(curOrg);
    user = encodeURIComponent(user);
    var v = "!" + curOrg + user; //KEYS MUST BE IN ALPHABETICAL ORDER! [ORG, USER]
    var crc = CRC32.str(v);
    var theURL =
      "/ServerSide/qactivityreport?org=" +
      curOrg +
      "&user=" +
      user +
      "&iv=" +
      crc +
      getsessioninfo();
    window.location.assign(theURL);
    SetOnBeforeUnload();
  }

  DoSPMetadata(entityID) {
    window.onbeforeunload = null;
    var theURL = "/saml/sso_metadata?entityID=" + entityID + "&return_type=download";
    window.location.assign(theURL);
    SetOnBeforeUnload();
  }

  PauseDrawing(pauseDrawing) {
    this.fPauseDrawing = pauseDrawing;
  }

  //var gRenderOvertime = null;
  RenderWSHandler() {
    this.RenderWS();
  }

  RenderWS() {
    if (this.fPauseDrawing) return;

    if (!Globals._allowRender) {
      this._renderQueued = true;
      return;
    }

    var d1 = new Date();
    Globals._renderStart = d1.getTime();

    this.SetHoverState();

    for (var aZLayerIdx = 0; aZLayerIdx < this.fZLayers.length; aZLayerIdx++) {
      var theLayer = this.fZLayers[aZLayerIdx];
      for (var aPanelIdx = 0; aPanelIdx < theLayer.length; aPanelIdx++) {
        var thePanel = theLayer[aPanelIdx];
        if (thePanel.IsShown() && thePanel.fNeedsRender) {
          thePanel.RenderPanel();
        }
      }
    }

    this.UpdateReactContext();
    this.FinishRenderWS();
  }

  // Coalesce repaints driven by continuous input (pan, wheel, touch) down to at most
  // one per animation frame. Dropping intermediate frames is safe because the next one
  // repaints from current pan state.
  // Only input handlers should use this. Anything that needs the canvas painted
  // before it returns must keep calling RenderWS directly.
  RequestRenderWS() {
    if (this._renderFrameHandle != null) return;

    // Non-browser hosts (jest, export workers) have no rAF; stay synchronous there.
    if (typeof requestAnimationFrame !== "function") {
      this.RenderWS();
      return;
    }

    this._renderFrameHandle = requestAnimationFrame(() => {
      this._renderFrameHandle = null;
      this.RenderWS();
    });
  }

  UpdateReactContext() {
    if (Globals._publishRef) return; // Skip React updates during export
    if (this.fReactContextProviderFn) this.fReactContextProviderFn({ state: this });
  }

  FinishRenderWS() {
    var ctx = this.fCanvas.getContext("2d");

    doDrawImage2(ctx, this.fBackBuffer, 0, 0);

    if (Globals._reportPerf) {
      var d2 = new Date();
      var e2 = d2.getTime();
      var elapsed = e2 - Globals._renderStart;
      //console.log("Render Time: " + elapsed.toString());
      Globals._rolling++;
      Globals._average += elapsed;
    }
  }

  IsTopPanelModal() {
    var numPanels = this.fPanels.length;
    var i = numPanels - 1;
    var done = false;
    if (i < 0) done = true;

    while (!done) {
      var thePanel = this.fPanels[i--];
      if (thePanel.IsShown()) {
        if (thePanel.GetModalOn()) return thePanel;
        else if (thePanel.fBackgroundPanel && thePanel.fBackgroundPanel.GetModalOn())
          return thePanel.fBackgroundPanel;
        else return null;
      }
      if (i < 0) done = true;
    }

    return null;
  }

  FindHitElement(x, y, mouseUp) {
    var panelHitInfo = new QPanelHitTest();
    for (var aZLayerIdx = this.fZLayers.length - 1; aZLayerIdx > -1; aZLayerIdx--) {
      var theZLayer = this.fZLayers[aZLayerIdx];
      for (var aPanelIdx = theZLayer.length - 1; aPanelIdx > -1; aPanelIdx--) {
        var thePanel = theZLayer[aPanelIdx];
        if (thePanel.IsShown() && thePanel.fNoHit !== true) {
          var panelModal = thePanel.GetModalOn();
          panelHitInfo = thePanel.HitTest(x, y, null);

          if (panelHitInfo.fPanelHit != null) return panelHitInfo;
          else if (panelModal) {
            if (thePanel.GetOutsideClickDismissOn()) {
              // We must be outside the panel since panelHitInfo.fPanelHit == null
              if (mouseUp) {
                panelHitInfo.fPanelHit = thePanel;
                panelHitInfo.fClickOutside = true;
              }
              return panelHitInfo;
            }
            return panelHitInfo;
          }
        }
      }
    }
    return panelHitInfo;
  }

  //=================================================================================================
  // Keyboard Handling
  AppHandleKeyboard(keyInfo) {
    // Override to handle keyboard events at WSMgr level
    return false;
  }

  FindCmdShortCut(keyInfo) {
    var numPanels = this.fPanels.length;
    var panelHitInfo = new QPanelHitTest();
    var done = false;
    var i = numPanels - 1;
    if (i < 0) done = true;

    while (!done) {
      var thePanel = this.fPanels[i--];
      if (thePanel.IsShown()) {
        var targetElement = thePanel.FindCmdShortCut(keyInfo);
        if (targetElement != null) {
          panelHitInfo.fPanelHit = thePanel;
          panelHitInfo.fElementHit = targetElement;

          this.SimulateMouseDown(targetElement);

          return panelHitInfo;
        }
      }
      if (i < 0 || thePanel.GetModalOn()) done = true;
    }

    return panelHitInfo;
  }

  SimulateMouseDown(targetElement) {
    // This should only happen if someone if firing off shortcuts super fast
    if (Globals._flashElement != null) handleSimTimer();

    Globals._flashElement = targetElement;
    Globals._flashElement["wsMgr"] = this;
    targetElement.SetDrawState(enumElementDrawStates.MouseDown);
    Globals._flashTimer = setInterval(function () {
      handleSimTimer();
    }, 125);

    // If the element does any magic on mouse up (like a toggle button then give it a chance)
    targetElement.DoHandleMouseUp();
  }

  WSHandleKeyboard(keyInfo) {
    var handled = false;
    var hitInfo = this.FindCmdShortCut(keyInfo);
    var hitPanel = hitInfo.fPanelHit;
    var hitElement = hitInfo.fElementHit;
    if (hitPanel != null) {
      if (hitElement != null) {
        var cmd = this.AssembleCommand(hitElement, hitPanel, null);
        this.ExecuteCommand(cmd);
        handled = true;
      }
    }
    if (!handled) {
      var genericKeyCmd = null;
      // ctrl key shortcuts
      if (keyInfo.ctrlKey) {
        genericKeyCmd = this.ConvertCtrlKeysToCmds(keyInfo);
      }
      // TODO add more generic keyboard shortcuts here
      if (genericKeyCmd !== null) {
        var wsCmd = this.AssembleCommand(this.fTargetElement, this.fTargetPanel, genericKeyCmd);
        this.ExecuteCommand(wsCmd);
        handled = true;
      }
    }
    return handled;
  }

  ConvertCtrlKeysToCmds() {}

  ExecuteAlertCommand() {
    return false;
  }

  HandleMouseBehaviorMods(keyInfo) {
    var keyCode = keyInfo.keyCode;
    switch (keyCode) {
      case kShiftKey:
        this.fShiftKeyDown = true;
        break;
      case kCtrlKey:
        this.fCtrlKeyDown = true;
        break;
    }
  }

  // All keyboard events start here!
  HandleKeyboard(event, keySource, keyInfoOverride) {
    var handled = false;
    var targetElement = this.fKeyboardTarget;

    var keyInfo;
    if (keyInfoOverride) {
      keyInfo = keyInfoOverride;
    } else {
      keyInfo = EventToKeyInfo(event, keySource);
      if (keyInfo.metaKey) {
        if (keyInfo.ctrlKey) {
          keyInfo.keyCode += 32;
        }
        keyInfo.ignoreEvent = false;
        keyInfo.ctrlKey = true;
      }
    }
    if (keyInfo.ignoreEvent) {
      this.HandleMouseBehaviorMods(keyInfo);
      return false;
    }

    // First let the target element deal with the keyboard
    if (targetElement != null) {
      //console.log("Pass to target Element: ", event.charCode, " ", keySource);
      handled = targetElement.ElementHandleKeyboard(keyInfo);
      //if (handled)
      //	console.log("Target Handled Keyboard");
    }

    // Second let the target panel deal with the keyboard
    var targetPanel = this.GetKeyboardTargetPanel();
    var targetElement = this.GetKeyboardTarget();
    if (!handled) {
      if (targetPanel != null)
        handled = targetPanel.PanelHandleKeyboard(keyInfo, targetElement, this); // event,keySource);
      //	if (handled)
      //		console.log("Panel Handled Keyboard");
    }

    // Third any application specific keyboard handling by WSMgr subclass
    if (!handled) {
      handled = this.AppHandleKeyboard(keyInfo);
      //	if (handled)
      //		console.log("App Handled Keyboard");
    }

    // Fourth any standard keyboard handling by WSMgr
    if (!handled) {
      handled = this.WSHandleKeyboard(keyInfo);
      //	if (handled)
      //		console.log("WS Handled Keyboard");
    }

    this.PrepRenderWS();
    this.RenderWS();

    return handled;
  }

  HandleKeyUp(event) {
    var keyCode = event.keyCode;

    switch (keyCode) {
      case kShiftKey:
        this.fShiftKeyDown = false;
        break;
      case kCtrlKey:
        this.fCtrlKeyDown = false;
        break;
    }
  }

  GetKeyboardTargetPanel() {
    return this.fKeyboardTargetPanel;
  }

  GetKeyboardTarget() {
    return this.fKeyboardTarget;
  }

  //=================================================================================================
  UndoBufferLength() {
    var theDoc = this.GetDoc();
    if (theDoc) return theDoc.UndoBufferLength();
    else return 0;
  }

  RedoBufferLength() {
    var theDoc = this.GetDoc();
    if (theDoc) return theDoc.RedoBufferLength();
    else return 0;
  }

  AltUndoLast() {
    return false;
    // Override
  }

  AltRedoLast() {
    return false;
    // Override
  }

  DoUndoLastTransaction(updateCode) {
    // Override
  }

  DoUndoAllBackgroundChanges(updateCode) {
    // Override
  }

  DoRedoLastTransaction(updateCode) {
    // Override
  }

  UndoLastTransaction() {
    var altUndo = this.AltUndoLast();
    if (altUndo) return;

    var theDoc = this.GetDoc();
    if (theDoc == null) return;

    var updateCode = theDoc.UndoLast();
    this.DoUndoLastTransaction(updateCode);

    this.BroadcastTopic("UndoChanges");
  }

  UndoAllBackgroundChanges() {
    var theDoc = this.GetDoc();
    if (theDoc == null) return;
    var updateCode = theDoc.UndoAll();
    this.DoUndoAllBackgroundChanges(updateCode);
  }

  RedoLastTransaction() {
    var altRedo = this.AltRedoLast();
    if (altRedo) return;

    var theDoc = this.GetDoc();
    if (theDoc == null) return;

    var updateCode = theDoc.RedoLast();
    this.DoRedoLastTransaction(updateCode);
  }

  // UNDOV2
  StartCheckPoint() {
    var theDoc = this.GetDoc();
    if (theDoc == null) return;

    theDoc.StartCheckPoint();
  }

  EndCheckPoint() {
    var theDoc = this.GetDoc();
    if (theDoc == null) return;

    theDoc.EndCheckPoint();
    this.SetDirty();
  }

  SetKeyboardTarget(targetElement, targetPanel, enterAction) {
    var curTargetElement = this.GetKeyboardTarget();
    if (curTargetElement != targetElement) {
      if (curTargetElement != null) {
        var curTargetPanel = this.GetKeyboardTargetPanel();
        curTargetElement.ExitKeyboardTarget(targetPanel, curTargetPanel);
      }
    }

    this.fKeyboardTarget = targetElement;
    this.fKeyboardTargetPanel = targetPanel;
    if (targetElement) targetElement.EnterKeyboardTarget(enterAction);
  }

  RegainKeyboardFocus() {
    var targetPanel = this.GetKeyboardTargetPanel();
    var targetElem = this.GetKeyboardTarget();
    if (targetElem == null || targetPanel == null) return;

    var keyboardInfo = targetElem.GetElementState();
    if (keyboardInfo == null) return;

    var tabID = keyboardInfo["id"];
    var targetKeyboard = targetPanel.GetTextEditByTabID(tabID);
    if (targetKeyboard == null || (targetKeyboard && !targetKeyboard.fEnabled)) return;

    var enterAction = keyboardInfo["action"];
    if (targetKeyboard.GetRealContent().length === 0) {
      keyboardInfo["start"] = 0;
      keyboardInfo["end"] = 0;
      keyboardInfo["control"] = 0;
    }
    targetKeyboard.fInsertionStart = keyboardInfo["start"];
    targetKeyboard.fInsertionEnd = keyboardInfo["end"];
    targetKeyboard.fControlInsertionStart = keyboardInfo["control"];
    this.SetKeyboardTarget(targetKeyboard, targetPanel, enterAction);
  }

  ResetKeyboardFocus() {
    this.SetKeyboardTarget(null, this.fKeyboardTargetPanel, enumKeyboardTargetEnterAction.noAction);
  }

  HandleCursor(hitTest) {
    var thePanel = hitTest.fPanelHit;
    if (thePanel != null) {
      var pCursor = null;
      var hitElement = hitTest.fElementHit;
      if (hitElement != null) {
        if (hitElement.HasSubCursor()) pCursor = hitElement.GetSubCursor(hitTest);
        else pCursor = hitElement.GetCursor();
      }
      if (pCursor == null) pCursor = thePanel.GetCursor();

      if (pCursor != this.fCurCursor) {
        try {
          this.fCanvas.style.cursor = pCursor;
        } catch (err) {
          console.log("Cursor Error");
        }

        this.fCurCursor = pCursor;
      }
    }
  }

  DoHandleHover(hoverMsg, elementX, elementY, yTop, mouseX, mouseY) {
    // Override this
  }

  HandleHover(hitTest, x, y) {
    var xE = x;
    var yE = y;
    var yTop = 0;
    var activeElement = null;
    var hoverMsg = null;
    if (hitTest.fElementHit != null) activeElement = hitTest.fElementHit;
    else if (hitTest.fDisabledElementHit != null) activeElement = hitTest.fDisabledElementHit;

    if (activeElement) {
      var thePanel = hitTest.fPanelHit;
      //var portOffSet = thePanel.fPanY;
      var portOffset = 0; //This is now handled by ElementGetPositionY...
      hoverMsg = activeElement.GetHoverMessage();
      if (hoverMsg && hoverMsg.IsCustomMsg()) {
        // Dynamic message
        //x = x + 16;
        yE = yE + 12 - portOffset;
      } else {
        xE = thePanel.GetElementPositionX(activeElement);
        yTop = thePanel.GetElementPositionY(activeElement);
        yE = yTop + activeElement.fHeight - portOffset;
      }
    }
    this.DoHandleHover(activeElement, xE, yE, yTop, x, y);
  }

  SetHoverElement(
    newElement //, prevHoverElement)
  ) {
    if (this.fPrevHoverElement) this.fPrevHoverElement.HoverTarget(false);

    this.fCurrentHoverElement = newElement;
    if (newElement) newElement.HoverTarget(true);
  }

  HandleMouseMove(x, y) {
    //	console.log("EnterMouseMove");
    this.ResetSessionTimer();

    var handled = false;
    var targetElement = this.fTargetElement;
    var targetPanel = this.fTargetPanel;
    var needPrepRender = true;
    var needRender = true;

    var isDragReady = this.fInteractMode === enumWSInteractMode.elementDragMode;

    var allowDrag = false;
    if (targetPanel && targetPanel.AllowToolMode(enumBasicToolModes.dragElem)) allowDrag = true;

    if (!isDragReady && allowDrag) isDragReady = DragReady(this, x, y);

    switch (this.fInteractMode) {
      case enumWSInteractMode.panMode:
        var deltaX = x - this.fDragStartx; // fPanStartx;
        var deltaY = y - this.fDragStarty; // fPanStarty;
        this.fTargetPanel.PanPanel(this.fOrigPanX, this.fOrigPanY, deltaX, deltaY);
        this.BroadcastTopic("BoundaryChange");
        // Claim the gesture so the hover/cursor block below is skipped.
        // Matches the mobile pan branch in standardMode, which already does this.
        handled = true;
        break;
      case enumWSInteractMode.marqueeMode:
        this.fTargetPanel.SetMarqueeRect(this.fDragStartx, this.fDragStarty, x, y);
        break;
      case enumWSInteractMode.standardMode:
        // Mobile only: a user may want to pan/scroll even if their initial touch was on a box
        if (
          Globals._mobileDevice &&
          this.fTargetPanel &&
          this.fTargetElement &&
          this.fTargetPanel.AllowToolMode(enumBasicToolModes.pan) &&
          !checkhysteresis(x, y, this.fDragStartx, this.fDragStarty)
        ) {
          this.HandlePanelPan(this.fTargetPanel, x, y);
          handled = true;
        }
        break;
      case enumWSInteractMode.elementDragMode:
        handled = true;
        if (targetElement) {
          var elemDragInfo = targetElement.GetElementDragInfo();
          if (isDragReady) {
            if (elemDragInfo != null) {
              targetElement.SetShownState(elemDragInfo.GetShowDragSourceElem());
            }
            this.fTargetPanel.PrepInteractWithElement(targetElement, x, y);
            this.HandleDrag(x, y);
            needRender = false;
            needPrepRender = false;
          }
        }
        break;
      case enumWSInteractMode.controlMode:
        if (targetElement) {
          if (!this.fTargetPanel.IsShown()) this.fTargetPanel.SetShownState(true);

          this.fTargetPanel.InteractWithElement(targetElement, x, y);
          if (targetElement.GeneratesInteractiveCmd()) {
            var cmd = this.AssembleCommand(targetElement, this.fTargetPanel, null);
            this.ExecuteCommand(cmd);
          }

          needPrepRender = false;
          handled = true;
        }
        break;
    }

    if (!handled) {
      var pHover = this.fPrevHoverElement;
      this.fPrevHoverElement = this.fCurrentHoverElement;
      if (targetElement != null) {
        // Mouse is down
        var hoverHitTest = this.FindHitElement(x, y, false);
        this.SetHoverElement(null); // pHover);
        //this.fCurrentHoverElement = null;
        if (hoverHitTest.fElementHit == targetElement)
          // Mouse is over the target
          targetElement.SetDrawState(enumElementDrawStates.MouseDown);
        // Mouse is not over the target
        else targetElement.SetDrawState(enumElementDrawStates.Std);
      } else {
        var hoverHitTest = this.FindHitElement(x, y, false); // FindHitElement2
        this.SetHoverElement(hoverHitTest.fElementHit); //,pHover);
        this.HandleHover(hoverHitTest, x, y);
        //	this.fCurrentHoverElement = hoverHitTest.fElementHit;
      }
      this.HandleCursor(hoverHitTest);

      //this.RenderWS();
    }

    if (needPrepRender) this.PrepRenderWS();

    if (needRender) this.RequestRenderWS();

    return handled;
    //	console.log("ExitMouseMove");
  }

  SetTarget(targetPanel, targetElement) {
    if (this.fTargetPanel != null && this.fTargetPanel != targetPanel)
      this.fTargetPanel.PanelLosingTarget();

    this.fTargetPanel = targetPanel;
    this.fTargetElement = targetElement;
  }

  HandleRightClick(x, y, event) {
    //   var handled = false;
    if (localStorage.rightclick == "false") return;
    this.PrepRenderWS();

    var hitTest = this.FindHitElement(x, y, false);
    var hitPanel = hitTest.fPanelHit;

    var e = hitTest.fElementHit;

    if (hitPanel != null) hitPanel.HandleRightClick(e, x, y, event);

    this.RenderWS();
  }

  HandlePaste(theContent) {}

  GetActiveDragPanel() {
    return this.fActiveDragPanel;
  }

  SetActiveDragPanel(thePanel) {
    this.fActiveDragPanel = thePanel;
  }

  HandleMouseDown(x, y) {
    //	var start = new Date().getTime();
    var im = this.fInteractMode;
    switch (im) {
      case enumWSInteractMode.controlMode:
      case enumWSInteractMode.elementDragMode:
      case enumWSInteractMode.marqueeMode:
        this.HandleMouseUp(x, y);
        return;
        break;
    }

    var handled = false;
    this.PrepRenderWS();

    var hitTest = this.FindHitElement(x, y, false);
    var hitPanel = hitTest.fPanelHit;

    if (hitPanel != null) {
      // In Pan Mode
      var panelMode = hitPanel.GetPanelMode();
      if (panelMode === enumPanelMode.panMode) {
        this.fInteractMode = enumWSInteractMode.panMode;
        this.fDragStartx = x;
        this.fDragStarty = y;
        this.SetTarget(hitPanel, null);
        hitPanel.ClearSelection();
        this.fOrigPanX = hitPanel.GetPanX();
        this.fOrigPanY = hitPanel.GetPanY();
        handled = true;
      }
    }

    // Clicked on an element
    if (hitTest.fElementHit != null && !handled) {
      this.SetTarget(hitTest.fPanelHit, hitTest.fElementHit);
      this.fTargetElement.SetDrawState(enumElementDrawStates.MouseDown);
      if (
        this.fTargetPanel.AllowToolMode(enumBasicToolModes.dragElem) &&
        this.fTargetElement.IsControl()
      ) {
        if (this.fTargetPanel.StartControlInteract(this.fTargetElement, x, y, this.ShiftDown())) {
          var elemDragInfo = this.fTargetElement.GetElementDragInfo();
          var elemDrag = this.fTargetElement.IsDraggable();
          var instantDrag = elemDragInfo ? elemDragInfo.GetInstantDrag() : false;

          if (this.fTargetPanel.fDraggerPanel) {
            this.RemovePanel(this.fTargetPanel.fDraggerPanel);
          }

          if (elemDragInfo == null || !this.fTargetElement.IsDragReady()) {
            this.fInteractMode = enumWSInteractMode.controlMode;
          } else if (Globals._uiConfig.InEditMode() || elemDrag || instantDrag) {
            // need override flag for chart box dragging where we dont require selection + drag combo
            var dragPanel = this.fTargetPanel.InitializeDragPanel(
              this,
              this.fTargetElement,
              x,
              y,
              this.ShiftDown()
            );
            if (dragPanel != null) {
              this.PushPanel(dragPanel);
              this.SetTarget(dragPanel, this.fTargetElement);
              this.fTargetPanel.fDraggerPanel = dragPanel;
            }
          }
          if (this.fTargetElement.WantsKeyboardInput())
            this.SetKeyboardTarget(
              this.fTargetElement,
              this.fTargetPanel,
              enumKeyboardTargetEnterAction.noAction
            );

          handled = true;
        }
      }

      if (
        this.fTargetPanel.AllowToolMode(enumBasicToolModes.select) &&
        this.fTargetElement.IsSelectable()
      ) {
        var checkValidHit = false;
        var targetSelected = this.fTargetElement.IsSelected();
        if (this.ShiftDown() && this.fTargetPanel.ShiftExtendsSelection()) {
          var didCustomSelect = this.fTargetPanel.CustomShiftSelect(this.fTargetElement);
          if (!didCustomSelect) {
            var allowSelect = this.fTargetPanel.AllowSelect(this.fTargetElement);
            if (!allowSelect) {
              hitTest.fPanelHit.ClearSelection();
              targetSelected = false;
            }

            if (this.fTargetElement["invalid"] == true)
              this.fTargetElement = this.fTargetPanel.ReacquireTarget(this.fTargetElement);
            if (this.fTargetElement) {
              var targetE = this.fTargetElement;
              this.fTargetPanel.DoSelectElement(targetE, !targetSelected);
            }
          }
          checkValidHit = true;
        } else {
          var nS = hitTest.fPanelHit.GetNumSelectedElements();
          if (targetSelected) this.fTargetElement.Reselect();

          if (!targetSelected || nS > 1) {
            var cntrSelect = this.CtrlDown() && this.fTargetPanel.CtrlExtendsSelection(); // ctrl click here with multiple selections should add to the selection cache
            if (!cntrSelect) {
              hitTest.fPanelHit.ClearSelection();
            }
            if (this.fTargetElement["invalid"] == true) {
              this.fTargetElement = this.fTargetPanel.ReacquireTarget(this.fTargetElement);
            }
            if (this.fTargetElement) {
              var targetE = this.fTargetElement;
              targetE.SetSubElement(hitTest.fDisabledElementHit);
              this.fTargetPanel.DoSelectElement(this.fTargetElement, true);
            }
            checkValidHit = true;
          }
        }
        if (checkValidHit && !hitTest.fPanelHit.IsElementActive(this.fTargetElement))
          hitTest.fPanelHit.ClearSelection();
        // Mobile: don't let selection claim this gesture, so a real drag can still be
        // recognized as a pan below (see the "In Pan Mode" block and HandleMouseMove).
        if (!Globals._mobileDevice) handled = true;
      }
      if (
        this.fTargetPanel.AllowToolMode(enumBasicToolModes.dragElem) &&
        this.fTargetElement.IsDragReady() &&
        this.fTargetElement.IsDraggable() &&
        !this.ShiftDown()
      ) {
        this.fTargetElement.fDragStartx = x;
        this.fTargetElement.fDragStarty = y;
        var elemDragInfo = this.fTargetElement.GetElementDragInfo();
        if (elemDragInfo == null) {
          this.fInteractMode = enumWSInteractMode.elementDragMode;
          this.DragInitiated();
          handled = this.HandleMouseMove(x, y);
        }
      }
    }
    if (hitPanel != null && !handled) {
      // Did not click on an element and in arrow mode with marquee enabled or in marqueeTool mode
      if (this.canStartMarquee(hitPanel, hitTest)) {
        this.fInteractMode = enumWSInteractMode.marqueeMode;
        this.fDragStartx = x;
        this.fDragStarty = y;
        this.SetTarget(hitPanel, null);
        this.fTargetPanel.SetMarqueeRect(this.fDragStartx, this.fDragStarty, x, y);
        handled = true;
      }
    }
    if (hitPanel != null && !handled) {
      // In Pan Mode
      var hitElem = hitTest.fElementHit;
      if (hitPanel.AllowToolMode(enumBasicToolModes.pan)) {
        if (hitElem == null) {
          this.HandlePanelPan(hitPanel, x, y);
        } else if (Globals._mobileDevice) {
          // Touch landed on an element: record where, in case the finger moves
          // enough to mean "pan/scroll" rather than "tap" (see HandleMouseMove).
          this.fDragStartx = x;
          this.fDragStarty = y;
        }
      }
    }
    this.RenderWS();

    //	var elapsed = new Date().getTime() - start;
    //	console.log("Mouse Down Elapsed time:", elapsed);
  }

  HandlePanelPan(panel, x, y) {
    panel.ClearSelection();
    panel.ClearHighlightCache();
    if (panel.fDynamicNoHit) {
      this.fDynamicNoHitTargetPanel = panel;
      panel.fNoHit = true;
      if (panel.fBackgroundPanel && panel.fBackgroundPanel.fDynamicNoHit)
        panel.fBackgroundPanel.fNoHit = true;
      var hitTest = this.FindHitElement(x, y, false);
      panel = hitTest.fPanelHit;
    }
    this.fInteractMode = enumWSInteractMode.panMode;
    this.fDragStartx = x;
    this.fDragStarty = y;
    this.SetTarget(panel, null);
    this.fOrigPanX = panel.GetPanX();
    this.fOrigPanY = panel.GetPanY();
    if (Globals._mobileDevice) {
      // in mobile, panning on a port list will want to hide keyboard to open space
      this.SetKeyboardTarget(null, this.GetKeyboardTargetPanel());
    }
  }

  HandleDrag(x, y) {
    var targetPanel = this.fTargetPanel;
    var targetElement = this.fTargetElement;
    var isDragPanel = this.fTargetPanel.fDraggerPanel != null;
    var dragTarget = isDragPanel ? targetPanel : targetElement;

    var startX = dragTarget.fDragStartx;
    var startY = dragTarget.fDragStarty;

    var deltaX = dragTarget.fLockDragX ? 0 : x - startX;
    var deltaY = dragTarget.fLockDragY ? 0 : y - startY;

    if (isDragPanel) {
      var newX = dragTarget.GetPositionX() + deltaX;
      var newY = dragTarget.GetPositionY() + deltaY;

      targetPanel.PositionPanel(newX, newY);
    } else {
      targetPanel.MoveElement(targetElement, deltaX, deltaY);
    }

    dragTarget.fDragStartx = x;
    dragTarget.fDragStarty = y;

    this.RenderWS();
  }

  StartDragInteraction(x, y) {
    var dragReady = false;
    if (this.fInteractMode != enumWSInteractMode.standardMode) return dragReady;

    var targetReady = this.fTargetPanel != null && this.fTargetElement != null;
    if (!targetReady) return dragReady;

    var dragger = this.fTargetPanel.fDraggerPanel;
    if (dragger != null) {
      if (checkhysteresis(x, y, dragger.fDragStartx, dragger.fDragStarty)) return dragReady;

      var targetElement = this.fTargetElement;
      var dragInfo = targetElement.GetElementDragInfo();
      if (dragger != null && !dragger.IsShown()) dragger.SetShownState(true);

      if (dragInfo != null) targetElement.SetShownState(dragInfo.GetShowDragSourceElem());

      this.RenderWS();
      this.DragInitiated();
      dragger.StartDragInteraction();
      this.SetActiveDragPanel(dragger);
      this.fInteractMode = enumWSInteractMode.elementDragMode;
      dragReady = true;
    }
    return dragReady;
  }

  DragInitiated() {
    // Override this
  }

  canStartMarquee(hitPanel, hitTest) {
    if (!hitPanel.AllowToolMode(enumBasicToolModes.marquee)) {
      return false;
    }

    let canMarquee = hitPanel.IsMarqueeEnabled();
    if (hitPanel.GetPanelMode() === enumPanelMode.implicitMode && !this.ShiftDown()) {
      canMarquee = false;
    }

    if (!canMarquee) {
      return false;
    }

    return (
      hitTest.fElementHit == null ||
      hitPanel.GetMarqueeBehavior() === enumMarqueeBehavior.partialOverlap
    );
  }

  HandleDoubleClick(x, y) {
    var hitTest = this.FindHitElement(x, y, false);
    var hitPanel = hitTest.fPanelHit;
    var hitElement = hitTest.fElementHit;

    this.SetTarget(hitPanel, hitElement);

    if (hitPanel != null) {
      var dblClickCmd = null;
      if (hitElement != null) dblClickCmd = hitElement.GetDblClickCmd();

      if (dblClickCmd == null) dblClickCmd = hitPanel.GetPanelDblClickCmd();
      if (dblClickCmd != null) {
        hitPanel.SetLastClick(x, y, true);
        var cmd = this.AssembleCommand(hitElement, hitPanel, dblClickCmd);
        this.DoCmdFromMouseUp(cmd);
      }

      this.HandleCursor(hitTest);
    }

    this.SetTarget(this.fTargetPanel, null);
    this.PrepRenderWS();
    this.RenderWS();
  }

  ExitModeOnMouseUp() {
    var exitMode = false;
    var targetElement = this.fTargetElement;

    switch (this.fInteractMode) {
      case enumWSInteractMode.panMode:
        this.fInteractMode = enumWSInteractMode.standardMode;
        exitMode = true;
        break;

      case enumWSInteractMode.marqueeMode:
        if (this.fTargetPanel == null) return exitMode;

        this.fInteractMode = enumWSInteractMode.standardMode;
        if (!this.fTargetPanel.NoDragMarquee()) {
          this.fTargetPanel.SelectElementsInMarquee(this.ShiftDown());
          exitMode = true;
        }
        this.fTargetPanel.ClearDrawMarquee();
        break;

      case enumWSInteractMode.elementDragMode:
        if (targetElement) {
          this.fInteractMode = enumWSInteractMode.standardMode;
          exitMode = true;
        }
        break;

      case enumWSInteractMode.controlMode:
        if (targetElement) {
          this.fInteractMode = enumWSInteractMode.standardMode;
          //targetElement.DoHandleMouseUp();
          exitMode = true;
        }
        break;
    }

    this.SetActiveDragPanel(null);
    return exitMode;
  }

  DoCmdFromMouseUp(cmd) {
    var oldTargetElement = this.fTargetElement;

    this.ExecuteCommand(cmd);
    //this.PrepRenderWS();

    if (oldTargetElement != null)
      if (oldTargetElement.IsEnabled()) oldTargetElement.SetDrawState(enumElementDrawStates.Std);

    //TODO add this later for more granularity
    //this.ReportEvent(cmd);
  }

  ReportEvent(aCmdObj) {
    if (aCmdObj == null) return;

    var trackerMgr = this.GetUsageTracker();
    if (trackerMgr == null) return;

    trackerMgr.ReportEvent(null, null, aCmdObj);
  }

  GetControlReleaseCmd() {
    // When a control is released we may want to fire a final command
    var cmd = null;
    var targetElement = this.fTargetElement;

    var issueControlRelease =
      this.fInteractMode == enumWSInteractMode.controlMode ||
      this.fInteractMode == enumWSInteractMode.elementDragMode;

    if (issueControlRelease && targetElement) {
      var cmdCode = targetElement.GetControlReleaseCmdCode();
      if (cmdCode != null) {
        cmd = this.AssembleCommand(targetElement, this.fTargetPanel, cmdCode);
      }
    }

    return cmd;
  }

  HandleMouseUp(x, y, event = null, canvas) {
    var isCanvasTarget = event?.target === canvas;
    var targetElement = this.fTargetElement;
    var noHitDynTargetPanel = this.fDynamicNoHitTargetPanel;

    if (noHitDynTargetPanel) {
      noHitDynTargetPanel.fNoHit = false;
      if (noHitDynTargetPanel.fBackgroundPanel) noHitDynTargetPanel.fBackgroundPanel.fNoHit = false;
    }

    var cmd = this.GetControlReleaseCmd();
    var handled = this.ExitModeOnMouseUp();

    if (isCanvasTarget && !handled) {
      var hitTest = this.FindHitElement(x, y, true);
      var hitPanel = hitTest.fPanelHit;
      var hitElement = hitTest.fElementHit;
      var outsideClick = hitTest.fClickOutside;

      if (hitPanel != null) {
        if (hitElement != null) {
          if (hitElement == targetElement) {
            hitElement.DoHandleMouseUp();
            cmd = this.AssembleCommand(hitElement, hitPanel, null, event);
          }
        } else {
          if (outsideClick) cmd = this.AssembleCommand(null, hitPanel, "CNCL");
          else {
            var clickCmd = hitPanel.GetPanelClickCmd();
            if (clickCmd != null) {
              hitPanel.SetLastClick(x, y, true);
              cmd = this.AssembleCommand(null, hitPanel, clickCmd);
            }
          }
        }
      }
    } else if (!isCanvasTarget && targetElement == null) {
      if (this.ActiveTextEntry()) {
        this.SetKeyboardTarget(null, this.fTargetPanel);
      }
    }

    if (cmd != null) {
      cmd["clientX"] = x;
      cmd["clientY"] = y;
      this.DoCmdFromMouseUp(cmd);

      // After the command executes the mouse might be over a different element
      var afterMouseUp = this.FindHitElement(x, y, false);
      this.HandleCursor(afterMouseUp);
      var currentElement = afterMouseUp.fElementHit;
      if (currentElement != null) {
        var restoreDrawState = Globals._mobileDevice
          ? enumElementDrawStates.Std
          : enumElementDrawStates.Hover;
        currentElement.SetDrawState(restoreDrawState);
      }
    } else if (Globals._mobileDevice) {
      afterMouseUp = this.FindHitElement(x, y, false);
      currentElement = afterMouseUp.fElementHit;
      if (currentElement != null) {
        currentElement.SetDrawState(enumElementDrawStates.Std);
      }
    } else if (handled) {
      afterMouseUp = this.FindHitElement(x, y, false);
      this.fPrevHoverElement = this.fCurrentHoverElement;
      this.SetHoverElement(afterMouseUp.fElementHit);
      this.HandleCursor(afterMouseUp);
    }

    this.SetTarget(this.fTargetPanel, null);

    if (isCanvasTarget || handled) {
      this.PrepRenderWS();
      this.RenderWS();
    }
  }

  HandleMouseEnter(x, y) {
    const activeDragPanel = this.GetActiveDragPanel();

    if (!activeDragPanel) {
      return;
    }

    activeDragPanel.SetShownState(true);
    const sourceElement = activeDragPanel.fSourceElement;
    this.SetTarget(activeDragPanel, sourceElement);
    this.fInteractMode = enumWSInteractMode.elementDragMode;
    this.DragInitiated();
  }

  DoHandleMouseWheel(direction, event) {
    // Override this
    return false;
  }

  HandleMouseWheel(direction, event) {
    if (this.DoHandleMouseWheel(direction, event)) {
      //event.stopPropagation();
      this.RequestRenderWS();
    }
  }

  DoHandleTouch(event) {
    // Override this
    return false;
  }

  HandleTouch(event) {
    if (this.DoHandleTouch(event)) {
      //event.stopPropagation();
      this.RequestRenderWS();
    }
  }

  DoHandleGesture(event) {
    // Override this
    return false;
  }

  HandleGesture(event) {
    if (this.DoHandleGesture(event)) {
      event.stopPropagation();
      return true;
    }
    this.fGestureTimeOut = setTimeout(function () {}, 1); // we are using this as timer to prevent multiple gesture handles within a certain time period
    return false;
  }

  CanDropUpload(x, y) {
    var canDrop = false;
    if (this.fFileMgr && this.fFileMgr.GetCanDropUpload()) return true;
    else {
      var dropTarget = this.FindDropTarget(x, y);
      if (dropTarget) {
        canDrop = dropTarget.GetDropEnabled();
      }
    }
    return canDrop;
  }

  HandleFiles(
    event,
    targetDirectory = null,
    fileRestrictions = [],
    allowMultiUpload = false,
    dropTarget
  ) {
    if (event.dataTransfer.files.length > 0) {
      var dt = event.dataTransfer;
      var files = dt.files;
      if (files && files.length > 1 && !allowMultiUpload) {
        var w = new QAlert();
        w.InitAlert(appstr("Alert"), appstr("uploadfailmultiplefiles"), null, this);
        return;
      }
      this.DoHandleFileDrop(files, targetDirectory, fileRestrictions, allowMultiUpload, dropTarget);
    }
  }

  FindDropTarget(x, y) {
    var hitTest = this.FindHitElement(x, y, false);
    var hitElement = hitTest.fElementHit;
    var hitPanel = hitTest.fPanelHit;

    return this.GetUploadTarget(hitPanel, hitElement);
  }

  FindActualDropTarget(x, y) {
    var hitTest = this.FindHitElement(x, y, false);
    var hitElement = hitTest.fElementHit;
    var hitPanel = hitTest.fPanelHit;
    var dropTarget = this.GetUploadTarget(hitPanel, hitElement);
    if (dropTarget) {
      var dropInfo = dropTarget.GetDropInfo();
      if (dropInfo["locateHitElement"] && hitElement != null && hitElement instanceof QChartBox)
        dropTarget = hitElement;
    }
    return dropTarget;
  }

  InitDragAndDropBox(event, x, y) {
    var dropTarget = this.FindDropTarget(x, y);
    if (dropTarget) dropTarget.DoHoverBox();
    this.PrepRenderWS();
    this.RenderWS();
  }

  GetUploadTarget(hitPanel, hitElem) {
    var dropTarget;
    var targetPanel = this.GetKeyboardTargetPanel();
    var targetDrop = targetPanel;
    if (this.fReactUploadTarget) targetDrop = this.fReactUploadTarget;

    var panelDropInfo = targetPanel ? targetPanel.GetDropInfo() : null;

    if (panelDropInfo == null) return;

    if (panelDropInfo["targetPanel"]) targetDrop = panelDropInfo["targetPanel"];

    var dropEnabled = targetDrop.GetDropEnabled();
    if (dropEnabled) dropTarget = targetDrop;

    return dropTarget;
  }

  CloseDragAndDropBox(event, x, y) {
    this.fDragDropTarget = null;
    var dropTarget = this.FindDropTarget(x, y);
    if (dropTarget) {
      dropTarget.HideHoverBox();
    }
    this.PrepRenderWS();
    this.RenderWS();
  }

  HandleResize(newWidth, newHeight, renderWS) {
    var origWidth = this.GetCanvasWidth();
    var origHeight = this.GetCanvasHeight();

    if (newWidth === -1) {
      newWidth = origWidth;
      origHeight = newHeight;
    } else {
      var canvasContainer = document.getElementById("canvasContainer");
      var rect = canvasContainer.getBoundingClientRect();
      setupCanvas(this.fCanvas, rect);
      this.fBackBuffer.width = Math.ceil(parseFloat(this.fCanvas.style.width.split("px")[0]));
      this.fBackBuffer.height = Math.ceil(parseFloat(this.fCanvas.style.height.split("px")[0]));
      setupCanvas(this.fBackBuffer);
    }

    // Clone is used for iteration since the size of wsmgr.fPanels can change due to panel resize routines
    // removing themselves in some cases (color picker, fileMgr additional info,
    var panelClone = [...this.fPanels];
    for (var i = 0; i < panelClone.length; i++) {
      var thePanel = panelClone[i];
      thePanel.Resize(origWidth, origHeight, newWidth, newHeight);
    }

    if (renderWS) this.RenderWS();
  }

  // Put together the QCmd Object
  AssembleCommand(theElement, thePanel, cmdCode, event) {
    var theCmd = new QCmd();
    var finalCmdCode = "XXXX";
    if (theElement != null) theElement.SetCmdParameters(theCmd);
    /*
     if (theElement != null)
       finalCmdCode = theElement.GetCmdCode();
     else
       finalCmdCode = cmdCode;
     */

    if (cmdCode != null) finalCmdCode = cmdCode;
    else if (theElement != null) {
      finalCmdCode = theElement.GetCmdCode();

      if (thePanel) {
        theCmd["xPos"] = thePanel.GetElementPositionX(theElement);
        theCmd["yPos"] = thePanel.GetElementPositionY(theElement) + theElement.fHeight;
      } else console.log("Panel is null - Assemble Command");
    }

    theCmd.InitCommand(finalCmdCode, theElement, thePanel, this, this.GetDoc());
    theCmd.fEvent = event;
    return theCmd;
  }

  //=================================================================================================
  // Command Handling
  DoExecuteCommand(aCmd) {
    // Override this
  }

  ExecuteCommand(aCmd) {
    var handled = this.DoExecuteCommand(aCmd);
    if (handled) return;

    handled = this.HandleClipboardCommand(aCmd);
    if (handled) return;

    return handled;
  }

  LoadComplete() {
    // Override this
  }

  //=================================================================================================
  // Common Prep
  ConfirmExit() {
    return null;
  }

  HandleAutoLogin() {
    return null;
  }

  PrepHandleEvent(mouseMoveEvent, x, y) {
    return null;
  }

  //=================================================================================================
  // Prep Render Optimization
  SubscribePrepRender(obj) {
    this.fPrepRenderSubs.push(obj);
  }

  UnsubscribePrepRender(obj) {
    var index = this.fPrepRenderSubs.indexOf(obj);
    if (index != -1) this.fPrepRenderSubs.splice(index, 1);
  }

  StartSessionTimer() {
    Globals._startTime = new Date();
    Globals._sessionTimerRef = this;
    this.ResetSessionTimer(true);
    Globals._sessionTimer = setTimeout(function () {
      checkSession();
    }, 1000);
  }

  ClearSessionTimer() {
    clearTimeout(Globals._sessionTimer);
    Globals._sessionTimer = null;
    this.ResetSessionTimer(true);
  }

  ResetSessionTimer(forceReset) {
    Globals._startTime = new Date();
  }

  // Create generic clipboard (only handles text) can be overridden for a custom clipboard
  CreateClipboard() {
    var cB = new QClipboard();
    cB.InitClipboard();
    return cB;
  }

  // Handle commands
  HandleClipboardCommand(aCmd) {
    var handled = true;
    var theCode = aCmd.GetCmdCode();
    switch (theCode) {
      case "Cut":
        this.DoCutCopy(null, true);
        break;
      case "Copy":
        this.DoCutCopy(null, false);
        break;
      case "Paste":
        this.DoPaste();
        break;
      case "CopyFormat":
        this.DoCopyFormat();
        break;
      default:
        handled = false;
        break;
    }

    return handled;
  }

  //=================================================================================================
  // Menu enabling
  CanCopy() {
    var canCopy = this.ActiveTextSelection();
    if (!canCopy) canCopy = this.CanCustomCopy();

    return canCopy;
  }

  // Override this is your app supports copying stuff other than text
  CanCustomCopy() {
    return false;
  }

  CanCut() {
    var canCut = this.ActiveTextSelection();
    if (!canCut) canCut = this.CanCustomCut();

    return canCut;
  }

  // Override this is your app supports cutting stuff other than text
  CanCustomCut() {
    return false;
  }

  //=================================================================================================
  // Clipboard Support
  CanCopyFormat() {
    return false;
  }

  CanCustomPaste(contentType) {
    // Override if needed
    return false;
  }

  CanPaste() {
    var canPaste = false;
    if (!this.fClipboard) this.fClipboard = this.CreateClipboard();
    var contentType = this.fClipboard.GetContentType();
    if (contentType == null) {
      //contentType = kCBTextContent;
      return;
    }

    if (contentType == kCBTextContent) {
      canPaste = this.ActiveTextEntry() || this.ActivePastePanel();
    }

    if (!canPaste) canPaste = this.CanCustomPaste(contentType);

    return canPaste;
  }

  //=================================================================================================
  DoCutCopy(event, doCut) {
    var tE = this.ActiveTextEntry();
    var canvas = document.getElementById("basecanvas");
    // if active element is not canvas, ignore canvas text edit
    var isCanvasTarget = document.activeElement === canvas;
    if (!isCanvasTarget) {
      tE = null;
    }
    var bufferString = null;
    var buffer = null;
    if (tE == null && !doCut) {
      //We're copying- so just grab the current target element and try to copy it.
      //We can try to make this smarter later on.
      tE = this.fTargetElement instanceof QChartBoxCell ? this.fTargetElement : null;
    }
    if (tE) bufferString = tE.DoCopy();
    //We still have nothing from our active element, but we have something from an event handler.
    if (bufferString == null && event && event.target.value != null)
      bufferString = event.target.value;
    //We don't have anything from an active text box or from an event handler, so we see if OCN can do this copying business.
    if (bufferString == null) {
      var currentPanel = this.GetCurrentPanel();
      var shouldCopy = !doCut || (currentPanel && currentPanel.ValidateCut(doCut));
      if (shouldCopy) buffer = this.CopyToClipboard();
      if (buffer && doCut) this.CustomDeleteSelection();
      //TODO: This won't work because of the circular structure.
      //bufferString = JSON.stringify(buffer);
    } else {
      buffer = new QClipboardBuffer();
      buffer.Init(bufferString, kCBTextContent, true);
    }
    if (bufferString != null) {
      if (!event || !event.clipboardData) copyTextToClipboardNoEvent(bufferString);
      else copyTextToClipboard(bufferString);
      this.fClipboard.SetContent(buffer, kCBTextContent);
    }
    if (tE && doCut) {
      if (!tE.IsContentMasked()) tE.InsertString("");
    }

    if (isCanvasTarget) {
      this.PrepRenderWS();
      this.RenderWS();
    }
  }

  CopyToClipboard() {
    var cbBuffer = this.DoCustomCopy();
    if (cbBuffer != null) this.fClipboard.SetContent(cbBuffer);
    return cbBuffer;
  }

  DoPaste() {
    // Undo here
    var theContent = this.fClipboard.GetContent();
    var contentType;

    if (theContent == null) {
      contentType = kCBTextContent;
      theContent = "Testing!";
    } else contentType = this.fClipboard.GetContentType();

    var customPaste = true;
    var tE = this.ActiveTextEntry();
    if (tE != null) {
      if (contentType == kCBTextContent) {
        tE.DoPaste(theContent);
        customPaste = false;
      }
    }

    if (customPaste) this.DoCustomPaste(this.fClipboard);
  }

  DoCopyFormat() {
    return null;
  }

  //=================================================================================================
  // Application specific clipboard handling
  DoCustomCopy() {
    // Override this
    return null;
  }

  DoCustomPaste() {
    // Override this
  }

  CustomDeleteSelection() {
    // Override this
    return;
  }

  //=================================================================================================
  // Helper functions
  ActiveTextSelection() {
    var isTextSelection = false;
    var activeText = this.ActiveTextEntry();
    if (activeText != null) isTextSelection = activeText.IsTextSelection();

    return isTextSelection;
  }

  ActiveTextEntry() {
    var activeText = null;
    var keyBoardTarget = this.GetKeyboardTarget();
    if (keyBoardTarget && keyBoardTarget.InEditMode()) activeText = keyBoardTarget;

    return activeText;
  }

  ActivePastePanel() {
    //only works for modal panels
    var topPanel = this.IsTopPanelModal();
    return topPanel && topPanel.CanPaste();
  }
}
